import { SPECIAL_ACCESS_ROUTES } from "src/constants/specialAccessUsers";

export const hasAccessToElement = (
  elementsRefs: string[],
  elementId: string
): boolean => {
  return elementsRefs.find(ele => ele === elementId) ? true : false;
};

export const isSpecialAccessRoute = (path: string): boolean => {
  return SPECIAL_ACCESS_ROUTES.includes(path);
};

export const isSpecialAccessUser = (
  username?: string | null,
  allowedUsernames: string[] = []
): boolean => {
  if (!username) return false;
  return allowedUsernames
    .map(item => item.toLowerCase())
    .includes(username.toLowerCase());
};

export const canAccessSpecialAccessRoute = (
  path: string,
  username?: string | null,
  allowedUsernames: string[] = []
): boolean => {
  if (!isSpecialAccessRoute(path)) return true;
  return isSpecialAccessUser(username, allowedUsernames);
};

export const canShowPagePath = (
  path: string,
  pagesAccessURLs: string[],
  username?: string | null,
  allowedUsernames: string[] = []
): boolean => {
  return (
    pagesAccessURLs.includes(path) &&
    canAccessSpecialAccessRoute(path, username, allowedUsernames)
  );
};
